<template>
  <validation-provider v-slot="{ errors }" rules="required">
    <v-select
      no-gutters
      outlined
      item-text="nome"
      item-value="abreviacao"
      :items="encodings"
      label="Codificação"
      v-model="encodingLocal"
      :error-messages="errors"
    />
  </validation-provider>
</template>

<script>
export default {
  props: {
    encoding: {
      type: String,
      required: true,
      default: 'UTF-8'
    }
  },

  data: () => ({
    encodings: [
      {nome: 'Unicode (UTF-8)', abreviacao: 'UTF-8'},
      {nome: 'ANSI (Windows-1252)', abreviacao: 'Windows-1252'},
      {nome: 'Europeu Ocidental (ISO-8859-1)', abreviacao: 'ISO-8859-1'}
    ]
  }),

  computed: {
    encodingLocal: {
      get() {
        return this.encoding;
      },
      set(newValue) {
        this.$emit('update:encoding', newValue);
      }
    }
  }
}
</script>